import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { useMenuVisibility } from '../../contexts/MenuVisibilityContext';

const PublicFooter = () => {
  const { menuItems: footerLinks, visibleSlugs } = useMenuVisibility();
  const [social, setSocial] = useState({ whatsapp: '', instagram: '' });

  useEffect(() => {
    if (!visibleSlugs.has('contact')) {
      setSocial({ whatsapp: '', instagram: '' });
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get('/public/contact');
        const data = res.data?.data;
        if (!cancelled && data) {
          setSocial({
            whatsapp: (data.whatsapp_link || '').trim(),
            instagram: (data.instagram_link || '').trim(),
          });
        }
      } catch {
        /* sección oculta o error */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [visibleSlugs]);

  const hasSocial = Boolean(social.whatsapp || social.instagram);

  return (
    <footer className="mt-auto border-t border-line bg-chrome pb-20 text-on-chrome lg:pb-0">
      <div className="mx-auto grid max-w-content gap-10 px-4 py-12 md:grid-cols-3 md:px-6 lg:px-8">
        <div>
          <p className="font-display text-2xl font-bold uppercase tracking-wide">Team Kitsune</p>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-white/70">
            Escuela de Kickboxing y FullContact.
          </p>
        </div>

        <div>
          <p className="font-display text-lg font-semibold uppercase tracking-wide">Enlaces</p>
          <ul className="mt-4 space-y-2">
            {footerLinks.map((link) => (
              <li key={link.slug}>
                <Link
                  to={link.path}
                  className="inline-flex min-h-10 items-center text-sm text-white/70 hover:text-white"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {hasSocial && (
          <div>
            <p className="font-display text-lg font-semibold uppercase tracking-wide">Síguenos</p>
            <div className="mt-4 flex gap-3">
              {social.instagram && (
                <a
                  href={social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-md border border-white/20 text-sm hover:border-white hover:bg-white/10"
                  aria-label="Instagram"
                >
                  IG
                </a>
              )}
              {social.whatsapp && (
                <a
                  href={social.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-md border border-white/20 text-sm hover:border-white hover:bg-white/10"
                  aria-label="WhatsApp"
                >
                  WA
                </a>
              )}
            </div>
          </div>
        )}
      </div>

      <div className="border-t border-white/10 px-4 py-4 text-center text-xs text-white/50">
        © {new Date().getFullYear()} KYZ. Todos los derechos reservados.
      </div>
    </footer>
  );
};

export default PublicFooter;
